import React from 'react';

interface NoteProps {
  label: string;
  children: React.ReactNode;
}

const Note: React.FC<NoteProps> = ({ label, children }) => (
  <div className="bg-surface border border-border-brand border-l-[3px] border-l-blue-link rounded-[6px] px-[16px] py-[12px] my-[10px] text-[13px] text-blue-deep-1 leading-[1.6]">
    <span className="font-bold mr-[6px]">{label}</span>
    {children}
  </div>
);

export default Note;
